import React, { FC, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import i18n from 'i18next';
import { GOOGLE_RECAPTCHA_SITE_KEY } from '~/env';
import { languagesConfig } from '~/utils/i18n';

interface Props {
  onChange?: (value: string | null) => void;
}

const CaptchaInput: FC<Props> = (props) => {
  const { onChange } = props;

  const recaptchaRef = React.createRef<ReCAPTCHA>();

  useEffect(() => {
    onChange?.(recaptchaRef?.current?.getValue() ?? null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const captchaLocale = languagesConfig[i18n.language].captchaLocale;

  return (
    <ReCAPTCHA
      key={captchaLocale} // rerender after language is changed
      hl={captchaLocale}
      ref={recaptchaRef}
      size="normal"
      sitekey={GOOGLE_RECAPTCHA_SITE_KEY ?? 'NO_KEY_ERROR'}
      onChange={(token) => onChange?.(token)}
    />
  );
};

export default CaptchaInput;
